// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"5ca86a97","386":"db5d43e5","574":"123fd98e"}[chunkId] + ".chunk.js";
};